import React from 'react';
import { Spin } from 'antd';
import { styled } from 'styled-components';
import { useGetCalculationConfigurationQuery } from '../../../../apis/apiGlobalConfiguration';
import { Row } from '@ydistri/ds';
import { EntityListDescriptionInfoIconTooltip } from '../../../ProjectAdministration/common/EntityListDescription';
import { useTemplateOrCalculationWithValue } from '../../../../hooks/useTemplateOrCalculationWithValue';

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const RequestListConfigurationInfo: React.FC = () => {
  const templateOrCalculation = useTemplateOrCalculationWithValue();

  const { data: calculationConfigurationData, isFetching } = useGetCalculationConfigurationQuery(
    templateOrCalculation.value,
  );

  const requestList = calculationConfigurationData?.ptRequestListEntityList;

  if (isFetching) {
    return <Spin spinning />;
  }
  if (!requestList) return null;

  return (
    <Row $gap="1rem">
      <InfoWrapper>{`Item count: ${requestList.skuCount}`} </InfoWrapper>
      {requestList.description && (
        <EntityListDescriptionInfoIconTooltip description={requestList.description} />
      )}
    </Row>
  );
};

export default RequestListConfigurationInfo;
